import { toast } from "sonner";

// Fecha de hoy en hora de Paraguay (UTC-3), igual que el backend
export const pyToday = () => new Date(Date.now() - 3 * 3600 * 1000).toISOString().slice(0, 10);

export function formatGs(n) {
  const num = Math.round(Number(n) || 0);
  return "Gs. " + num.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ".");
}

export function waLink(phone, text) {
  let digits = String(phone || "").replace(/\D/g, "");
  if (digits.startsWith("0")) digits = digits.slice(1);
  if (!digits.startsWith("595")) digits = "595" + digits;
  return `https://wa.me/${digits}?text=${encodeURIComponent(text || "")}`;
}

// Abre WhatsApp; si el navegador bloquea la ventana (Safari tras una espera), ofrece un botón para abrirlo
export function openWa(url) {
  const w = window.open(url, "_blank");
  if (!w) toast("Mensaje de WhatsApp listo", { duration: 20000, action: { label: "Abrir WhatsApp", onClick: () => window.open(url, "_blank") } });
}

export const STATUS_META = {
  solicitado: { label: "Solicitado", group: "creado", dot: "#64748B" },
  retirado: { label: "Retirado", group: "creado", dot: "#64748B" },
  depositado_origen: { label: "Depositado en origen", group: "creado", dot: "#64748B" },
  embarcado: { label: "Embarcado", group: "en_transito", dot: "#3B82F6" },
  en_transito: { label: "En tránsito", group: "en_transito", dot: "#3B82F6" },
  desembarcado: { label: "Desembarcado", group: "en_transito", dot: "#3B82F6" },
  en_sucursal_destino: { label: "En sucursal destino", group: "en_transito", dot: "#3B82F6" },
  asignado_repartidor: { label: "Asignado a repartidor", group: "en_reparto", dot: "#F5A623" },
  en_reparto: { label: "En reparto", group: "en_reparto", dot: "#F5A623" },
  entregado: { label: "Entregado", group: "entregado", dot: "#10B981" },
  incidente: { label: "Incidencia", group: "incidencia", dot: "#EF4444" },
  devuelto: { label: "Devuelto", group: "incidencia", dot: "#EF4444" },
  almacenado: { label: "Almacenado en sucursal", group: "almacenado", dot: "#8B5CF6" },
  reasignado: { label: "Reasignado", group: "resuelto", dot: "#0D9488" },
  devuelto_origen: { label: "Devuelto a origen", group: "resuelto", dot: "#0D9488" },
  dispuesto: { label: "Dispuesto / desechado", group: "cerrado", dot: "#475569" },
  anulado: { label: "Anulado", group: "cerrado", dot: "#475569" },
};

export const GROUP_META = {
  creado: { label: "Creado", dot: "#64748B", pill: "bg-slate-100 text-slate-700 border-slate-200" },
  en_transito: { label: "En tránsito", dot: "#3B82F6", pill: "bg-blue-50 text-blue-700 border-blue-200" },
  en_reparto: { label: "En reparto", dot: "#F5A623", pill: "bg-amber-50 text-amber-800 border-amber-200" },
  entregado: { label: "Entregado", dot: "#10B981", pill: "bg-emerald-50 text-emerald-700 border-emerald-200" },
  incidencia: { label: "Incidencia", dot: "#EF4444", pill: "bg-rose-50 text-rose-700 border-rose-200" },
  almacenado: { label: "Almacenado", dot: "#8B5CF6", pill: "bg-violet-50 text-violet-700 border-violet-200" },
  resuelto: { label: "Resuelto", dot: "#0D9488", pill: "bg-teal-50 text-teal-700 border-teal-200" },
  cerrado: { label: "Anulado / Dispuesto", dot: "#475569", pill: "bg-zinc-100 text-zinc-600 border-zinc-300" },
};

export const MODALIDADES = [
  { id: "cod", label: "Pago contra entrega (COD)", desc: "Destinatario paga producto + flete" },
  { id: "destino", label: "Cobro en destino", desc: "Destinatario paga solo el flete" },
  { id: "contado", label: "Contado (paga el remitente)", desc: "Flete pagado en origen · destinatario Gs. 0" },
  { id: "envio_pagado", label: "Envío pagado por remitente", desc: "Destinatario paga solo el producto" },
  { id: "credito", label: "Crédito (cuenta del remitente)", desc: "Destinatario paga el producto · flete a crédito del remitente" },
];

export const ROLE_LABELS = {
  admin: "Administrador",
  encargado: "Encargado de Sucursal",
  encargado_comisionista: "Encargado Comisionista",
  repartidor: "Repartidor",
  comisionista: "Comisionista",
  punto: "Punto Pya'elino",
  cliente: "Cliente",
};

export function avisoEntregaRemitente(env) {
  if (!env?.remitente_whatsapp) return false;
  const cobrado = env.modalidad === "cod" ? `\nCobrado: ${formatGs(env.monto_cobrado || env.cobro_destinatario || 0)}` : "";
  const receptor = env.comprobante?.receptor ? `\nRecibido por: ${env.comprobante.receptor}` : "";
  const text = `Aviso de entrega · Pya'elino Courier\nTu encomienda ${env.code} fue entregada en destino: ${env.ciudad}.${receptor}${cobrado}`;
  openWa(waLink(env.remitente_whatsapp, text));
  return true;
}
